import React, { useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { ShoppingCart } from "lucide-react";
import { addToCart } from "../../actions/cartActions";
import { getSafeUserMessage } from "../../utils/errorMessages";

export default function BuyAgainButton({ item }) {
  const dispatch = useDispatch();
  const locked = useRef(false);
  const [state, setState] = useState("");
  const [error, setError] = useState("");
  if (!item.productId || item.productType === "service") return null;
  async function buyAgain() {
    if (locked.current) return;
    locked.current = true;
    setState("busy"); setError("");
    try {
      await dispatch(addToCart({ productId: item.productId, variantSku: item.variantSku, variantType: item.variantType, qty: item.qty }));
      setState("added");
    } catch (err) { setError(getSafeUserMessage(err.message, "This item is not available to buy again.")); setState(""); }
    finally { locked.current = false; }
  }
  return <div>
    <button type="button" className="order-detail__button" onClick={buyAgain} disabled={state === "busy" || state === "added"}>
      <ShoppingCart size={16} aria-hidden="true" /><span>{state === "busy" ? "Adding..." : state === "added" ? "Added to basket" : "Buy again"}</span>
    </button>
    {state === "added" ? <small role="status">Added at the current price. Review your basket before checkout.</small> : null}
    {error ? <small role="alert">{error}</small> : null}
  </div>;
}
